// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"7074":"7cdedef1","8891":"75666b8d"}[chunkId] || chunkId) + "." + {"3348":"57a98d7658cdfb03","3459":"fd11f16d82ddb087","6625":"5c04583a232cc471","7074":"093d66bd3666db23","7195":"74fae0cde54fa1b4","7920":"915e67d359168a34","8891":"bbcff618c8cd4f32"}[chunkId] + ".js";
};